import { triggerLink } from 'common/util'

import styles from './index.module.scss'

interface IBannerProps {
  banner: string
  id: number
  title: string
  value: string
  art_id: string
  befortrigger?: () => void
}

const Banner = ({
  id,
  banner,
  value: url,
  title,
  art_id,
  befortrigger
}: IBannerProps) => {

  const openLink = () => {
    if (!url) return
    befortrigger && befortrigger()
    const link = url.includes('?') ? `${url}&entry_id=${art_id}` : `${url}?entry_id=${art_id}`
    triggerLink(link)
  }

  return (
    <div className={styles.news} onClick={openLink}>
      <img src={banner} alt="banner" />
    </div>
  )
}

export default Banner
